import axios from 'axios';

const baseURL = process.env.REACT_APP_API_USUARIO + '/language';

async function setLanguageCastellano() {
    const { data } = await axios.post(`${baseURL}/castellano`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function setLanguageIngles() {
    const { data } = await axios.post(`${baseURL}/english`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function setLanguageCatalan() {
    const { data } = await axios.post(`${baseURL}/catala`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function setLanguageGallego() {
    const { data } = await axios.post(`${baseURL}/galego`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function setLanguageEuskera() {
    const { data } = await axios.post(`${baseURL}/euskera`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

async function setLanguageValenciano() {
    const { data } = await axios.post(`${baseURL}/valencia`,
        {},
        {
            withCredentials: true,
            headers: {
                'access-control-allow-origin': '*',
                'access-control-allow-credentials': 'true',
                'content-type': 'application/json'
            }
        });
    return data;
};

export default { setLanguageCastellano, setLanguageIngles, setLanguageCatalan, setLanguageGallego, setLanguageEuskera, setLanguageValenciano };